import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Button,
  Link,
} from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

const SAFFRON = "#E07B1A";
const SAFFRON_DARK = "#854F0B";
const SAFFRON_PALE = "#FAEEDA";

const DEED_URL =
  "https://drive.google.com/file/d/1edrVSQq11K7NqZADBdG2ByxUH8fuqCFY/preview";
const DEED_VIEW_URL =
  "https://drive.google.com/file/d/1edrVSQq11K7NqZADBdG2ByxUH8fuqCFY/view";

export default function Deeds() {
  return (
    <Box maxW="900px" mx="auto" p={{ base: 4, md: 8 }}>
      {/* ── Hero ── */}
      <VStack spacing={3} textAlign="center" mb={8}>
        <Box fontSize="40px" lineHeight="1">
          📜
        </Box>
        <Heading fontSize={{ base: "2xl", md: "3xl" }} color={SAFFRON}>
          Trust Deed Document
        </Heading>
        <Box w="48px" h="2px" bg={SAFFRON} borderRadius="full" opacity={0.6} />
      </VStack>

      {/* ── Intro card ── */}
      <Box
        p={5}
        mb={8}
        borderRadius="16px"
        bg={SAFFRON_PALE}
        border="1px solid"
        borderColor="orange.200"
      >
        <HStack align="start" spacing={3}>
          <Text fontSize="24px">📄</Text>
          <Box>
            <Text fontWeight="700" color={SAFFRON_DARK} mb={1}>
              Official Registration
            </Text>
            <Text fontSize="sm" color="gray.700" lineHeight="1.8">
              Below is the official deed of the{" "}
              <strong>
                "Sri Annapurna Sametha Visweswara Swamy Alaya Trust"
              </strong>{" "}
              registered on 14th June, 2025. It outlines the mission, values,
              and governance of the trust.
            </Text>
          </Box>
        </HStack>
      </Box>

      {/* ── Deed viewer ── */}
      <HStack
        justify="space-between"
        align="center"
        mb={4}
        flexWrap="wrap"
        gap={2}
      >
        <Heading fontSize="lg" color={SAFFRON_DARK}>
          Document Preview
        </Heading>
        <Link
          href={DEED_VIEW_URL}
          isExternal
          _hover={{ textDecoration: "none" }}
        >
          <Button
            size="sm"
            variant="outline"
            borderColor={SAFFRON}
            color={SAFFRON_DARK}
            borderRadius="full"
            rightIcon={<ExternalLinkIcon />}
            _hover={{ bg: "orange.50" }}
          >
            Open in new tab
          </Button>
        </Link>
      </HStack>

      <Box
        borderRadius="16px"
        overflow="hidden"
        border="1px solid"
        borderColor="orange.200"
        boxShadow="0 6px 20px rgba(133,79,11,0.1)"
      >
        <iframe
          src={DEED_URL}
          width="100%"
          height="600px"
          title="Trust Deed PDF"
          style={{ border: 0, display: "block" }}
          allow="autoplay"
        />
      </Box>

      <Text fontSize="xs" color="gray.500" mt={3} textAlign="center">
        If the preview doesn't load, use "Open in new tab" above to view the
        full document on Google Drive.
      </Text>
    </Box>
  );
}
